import React from 'react';
import { Smartphone, ChevronRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const SPLASH = 'https://images.weserv.nl/?url=customer-assets-lxgj4vgw.emergentagent.net/job_d4b3d2e1-67da-40cf-8efa-61dbe3f79433/artifacts/x0z4nhag_Captura%20principal.png&w=280&q=80&output=webp';

const AppPromoSection = () => {
  const { language } = useLanguage();
  const isES = language === 'es';
  return (
    <section className="py-10" data-testid="app-promo-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-r from-[#0B1E3D] via-[#0F2645] to-[#16324F] shadow-2xl">
          <div className="absolute -top-24 -right-24 w-80 h-80 bg-[#FF6B35]/20 rounded-full blur-[100px]" aria-hidden="true"></div>
          <div className="absolute inset-0" style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)', backgroundSize: '48px 48px' }} aria-hidden="true"></div>
          <div className="relative z-10 flex flex-col md:flex-row items-center gap-6 md:gap-10 px-6 sm:px-10 py-8">
            <img
              src={SPLASH}
              alt={isES ? 'App ASOFOM' : 'ASOFOM App'}
              className="w-24 sm:w-28 rounded-2xl border-2 border-white/20 shadow-2xl -rotate-3 hidden sm:block"
              loading="lazy"
            />
            <div className="flex-1 text-center md:text-left">
              <div className="inline-flex items-center gap-2 bg-[#FF6B35]/15 border border-[#FF6B35]/40 rounded-full px-3 py-1 mb-3">
                <Smartphone className="w-3.5 h-3.5 text-[#FF6B35]" />
                <span className="text-[11px] font-bold text-[#FF6B35] uppercase tracking-wider">{isES ? 'App oficial del evento' : 'Official event app'}</span>
              </div>
              <h3 className="text-white text-xl sm:text-2xl font-bold leading-tight">
                {isES ? 'La Convención sigue viva en la App' : 'The Convention lives on in the App'}
              </h3>
              <p className="text-white/60 text-sm mt-1.5 max-w-xl">
                {isES
                  ? 'Revive las sesiones, recupera los contactos que hiciste con Lead Scan y mantente al tanto de la 21ª Convención antes que nadie.'
                  : 'Relive the sessions, recover the contacts you made with Lead Scan and stay tuned for the 21st Convention before anyone else.'}
              </p>
            </div>
            <a
              href="/app-asofom"
              data-testid="app-promo-section-cta"
              className="inline-flex items-center gap-2 bg-[#FF6B35] hover:bg-[#E55A28] text-white font-bold px-7 py-3.5 rounded-full shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5 whitespace-nowrap"
            >
              {isES ? 'Descubre la App' : 'Discover the App'}
              <ChevronRight className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppPromoSection;
